/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CreateFabricTableShortcutDemoRequestShortcutsInner } from '../models/CreateFabricTableShortcutDemoRequestShortcutsInner';

export class CreateFabricTableShortcutDemoRequest {
  /**
  * List of Fabric table shortcuts to create
  */
  'shortcuts': Array<CreateFabricTableShortcutDemoRequestShortcutsInner>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "shortcuts",
      "baseName": "shortcuts",
      "type": "Array<CreateFabricTableShortcutDemoRequestShortcutsInner>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CreateFabricTableShortcutDemoRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

